<template>
  <el-row
    class="widget-view el-form-item"
    v-if="element && element.key"
    :class="{ active: selectWidget.key == element.key }"
    :key="element.key"
    @click.native.stop="handleSelectWidget(index)"
  >
    <template v-if="element.type == 'divider'">
      <el-divider
        v-if="element.options.showLine"
        :direction="element.options.directionValue"
        :content-position="element.options.contentPositionValue"
      >
        <div v-html="element.options.defaultValue"></div>
      </el-divider>
      <div
        v-if="!element.options.showLine && !element.options.isTextEditor"
        v-html="element.options.defaultValue"
      ></div>
      <divider
        v-if="!element.options.showLine && element.options.isTextEditor"
        v-model="element.options.defaultValue"
      />
    </template>
    <template v-if="element.type == 'button'">
      <el-button
        :type="element.options.type"
        :size="element.options.size"
        :round="element.options.clazz === 'round'"
        :circle="element.options.clazz === 'circle'"
      >
        {{ element.name }}</el-button
      >
    </template>
    <template v-if="element.type == 'hidden'">
      <el-input
        v-model="element.options.defaultValue"
        suffix-icon="el-icon-view"
        :style="{ width: element.options.width }"
      ></el-input>
    </template>
    <div class="widget-view-action" v-if="selectWidget.key == element.key">
      <i
        class="el-icon-document-copy"
        @click.stop="handleWidgetClone(index)"
      ></i>
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>

    <div class="widget-view-drag" v-if="selectWidget.key == element.key">
      <i class="su-icon-tuodong drag-widget"></i>
    </div>
  </el-row>
</template>

<script>
import divider from './divider'
export default {
  name: 'advanced-form-item',
  props: ['element', 'select', 'index', 'data', 'dataConfig'],
  components: {
    divider,
  },
  data() {
    return {
      selectWidget: this.select,
    }
  },
  mounted() {},
  methods: {
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length === 1) {
        this.$emit('select-change', -1)
      } else {
        if (this.data.list.length - 1 === index) {
          this.$emit('select-change', index - 1)
        } else {
          this.$emit('select-change', index)
        }
      }

      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
    handleWidgetClone(index) {
      const key = new Date().getTime() + ''
      let cloneData = {
        ...this.data.list[index],
        options: { ...this.data.list[index].options },
        eventOptions: { ...this.data.list[index].eventOptions },
        key,
        model: this.data.list[index].type + key,
      }

      // eslint-disable-next-line no-prototype-builtins
      if (this.data.list[index].options.hasOwnProperty('options')) {
        cloneData = {
          ...cloneData,
          options: {
            ...cloneData.options,
            options: cloneData.options.options.map(item => ({ ...item })),
          },
        }
      }

      this.data.list.splice(index, 0, cloneData)

      this.$nextTick(() => {
        this.selectWidget = this.data.list[index + 1]
      })
    },
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true,
    },
  },
}
</script>
<!--
<style scoped lang="sass">
    $sw-el-divider-color: red
    $sw-el-divider-height: 10px
    .el-divider
        background-color: $sw-el-divider-color
    .el-divider&#45;&#45;horizontal
        height: $sw-el-divider-height
</style>
-->
